import { Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser } from '@angular/common';
import { CommonService } from 'src/app/services/common.service';
import { DashboardService } from '../services/dashboard.service';
declare var $: any

@Component({
  selector: 'app-verify-student-detail',
  templateUrl: './verify-student-detail.component.html',
  styleUrls: ['./verify-student-detail.component.css']
})
export class VerifyStudentDetailComponent implements OnInit {
  data: any = {}
  @ViewChild('video', { static: true }) video: ElementRef<HTMLVideoElement>;
  v_
  constructor(private userService: LoginService,@Inject(PLATFORM_ID) private _platform: Object,private dashboardService:DashboardService,
     private route: Router, private toastr: ToastrService,
      private CommonService: CommonService) { }

  ngOnInit(): void {
    this.init();
    // if (isPlatformBrowser(this._platform) && 'mediaDevices' in navigator) {
    //   navigator.mediaDevices.getUserMedia({ video: true }).then((ms: MediaStream) => {
    //     const _video = this.video.nativeElement;
    //     _video.srcObject = ms;
    //     _video.play();
    //   });
    // }
   // document.getElementById('enableCamera').click();
  }
  registerUser() {
    let user = this.data;
    this.userService.veryStudent(user).subscribe((succ) => {
      
      let userData: any = succ ?? {};
      if(userData){
        this.CommonService.userId = userData.USERID
        localStorage.setItem('UserId', userData.USERID);
        localStorage.setItem('Username', userData.FIRSTNAME);
        localStorage.setItem('TenantCode', userData.TENANTCODE)
        localStorage.setItem('RoleId', userData.Encrypt_Role)
        localStorage.setItem('DICTIONARYCODE', userData.DICTIONARYCODE)
        localStorage.setItem('CourseId',userData.CourseId);
        this.toastr.success('Please wait verifying student Roll Number');
        // if(userData.USERID){
        //   this.dashboardService.getCource().subscribe((data: any) => {
        //     console.log('dashboardService...',data)
        //     // this.course = { ...this.course, ...data }
        //     // this.stopSpinner()
        //   }, (e) => {
      
        //     //this.stopSpinner()
        //   })
        // }
        this.route.navigate(['/login'])
  
      }

    }, (err) => {

      let e = err.error;

      this.toastr.error(e.text || 'Please try again later')
    })
  }

  init() {
    let self = this;
    $('.input100').each(function () {
      $(this).on('blur', function () {
        if ($(this).val().trim() != "") {
          $(this).addClass('has-val');
        }
        else {
          $(this).removeClass('has-val');
        }
      })
    })

    var input = $('.validate-input .input100');

    $('.validate-form').on('submit', function () {
      var check = true;

      for (var i = 0; i < input.length; i++) {
        if (validate(input[i]) == false) {
          showValidate(input[i]);
          check = false;
        }
      }
      if (check) {
        self.registerUser()
      }
      return check;
    });


    $('.validate-form .input100').each(function () {
      $(this).focus(function () {
        hideValidate(this);
      });
    });

    function validate(input) {
      // return true
      if ($(input).attr('type') == 'email' || $(input).attr('name') == 'email') {
        return true
        if ($(input).val().trim().match(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/) == null) {
          return false;
        }
      }
      else {
        if ($(input).val().trim() == '') {
          return false;
        }
      }
    }

    function showValidate(input) {
      var thisAlert = $(input).parent();

      $(thisAlert).addClass('alert-validate');
    }

    function hideValidate(input) {
      var thisAlert = $(input).parent();

      $(thisAlert).removeClass('alert-validate');
    }

    var showPass = 0;
    $('.btn-show-pass').on('click', function () {
      if (showPass == 0) {
        $(this).next('input').attr('type', 'text');
        $(this).find('i').removeClass('zmdi-eye');
        $(this).find('i').addClass('zmdi-eye-off');
        showPass = 1;
      }
      else {
        $(this).next('input').attr('type', 'password');
        $(this).find('i').addClass('zmdi-eye');
        $(this).find('i').removeClass('zmdi-eye-off');
        showPass = 0;
      }

    });

  }



}
